"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("waypoints/lib/jquery.waypoints");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notifications = void 0;

var url_to_array = void 0;

url_to_array = require("../helpers/url_to_array").default;

Notifications = function () {
    function Notifications() {
        var _this = this;

        var $activity = void 0;
        var $loading = void 0;
        var loading = void 0;
        var no_results = void 0;
        var page = void 0;
        var url = void 0;
        $activity = (0, _jquery2.default)("#activity-list");
        url = "//" + url_to_array[2] + "/" + url_to_array[3] + "/activity/";
        page = 2;
        no_results = void 0;
        loading = '<div class="loading clearfix"> <div class="dot dot1"></div> <div class="dot dot2"></div> <div class="dot dot3"></div> <div class="dot dot4"></div> </div>';
        $activity.parent().append(loading);
        $loading = (0, _jquery2.default)(".loading");
        $loading.addClass("hidden");

        // clear notifications
        _jquery2.default.get("/clear-notications/").done(function () {});

        (0, _jquery2.default)("#logout-form").waypoint({
            handler: function handler() {
                if (no_results !== true) {
                    $loading.removeClass("hidden");
                    if (!_this.fetching) {
                        _this.fetching = true;
                        return _jquery2.default.get(url + "?page=" + page, function (data) {
                            _this.fetching = false;
                            page = page + 1;
                            $activity.append(data);
                            (0, _jquery2.default)(".loading").addClass("hidden");
                            Waypoint.refreshAll();
                        }).fail(function () {
                            _this.fetching = false;
                            $loading.addClass("hidden");
                            return no_results = true;
                        });
                    }
                }
            },
            offset: "110%"
        });
    }

    return Notifications;
}();

exports.default = Notifications;